/**
 * Sample Status master — shared identifiers for the seeded default status.
 *
 * Frontend mirror of `server/constants/sample-status.constants.ts`. The two bundles cannot share a
 * module, so keep them in step: the server seeds and enforces these values, the frontend renders
 * and locks against them.
 */

/**
 * refKey of the seeded default sample status. Identity lives on refKey, never on `name`: the name
 * is user-editable in the master (tenants have renamed '-' to 'Pending'), refKey is not.
 */
export const DEFAULT_SAMPLE_STATUS_REF_KEY = '-' as const;

/**
 * Fixed display colour of the default sample status. Doubles as the swatch CSS class name
 * (`.rount-shape.amber`), so the value must stay a valid colour class.
 */
export const DEFAULT_SAMPLE_STATUS_COLOR = 'amber' as const;
